/*
 * Transcript View Template Messages
 *
 * This contains all the text for the Transcript View Template component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  notFound: {
    id: 'TranscriptViewTemaplate.notFound',
    defaultMessage: 'Transcript not found',
  },
  failed: {
    id: 'TranscriptViewTemaplate.failed',
    defaultMessage: 'Failed to fetch the transcript',
  },
});



// WEBPACK FOOTER //
// ./components/templates/TranscriptView/messages.js